import type { FaireProductEntity } from "../../entity_types/product";

export const p_tdmube86av: FaireProductEntity = {
  token: "p_tdmube86av",
  type: "product",
  name: "Sun Plush Throw - Buckhorn Brown",
  brandToken: "b_3ltt834j6o",
  brandName: "Sundream",
  imageUrl:
    "https://cdn.faire.com/fastly/80c74304a7aa9635a72ebaf0f285eaffdb839904b46ba784ea9b60596ffe8328.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8c631b1b66202ff8d638c1368ba826a56eba98e84a944f2fae393d35a022d758.png",
    "https://cdn.faire.com/fastly/d942c9ef73f67d67614601e72a4879e7d76332e86c76ac8dff58f5fcf971add7.png",
    "https://cdn.faire.com/fastly/e657816d8e0a4a0bb191eb1612d37201bab0006c73f909bba1d00514c167fbb9.png",
    "https://cdn.faire.com/fastly/50de67abf49c2a80ab495dd00d5bf6f3ada878d4c4bd180a76ca61e223ff8b49.png",
    "https://cdn.faire.com/fastly/b5d314772b58717b677bdec0d97a89632948ea4946bec548f4caa19de5debcc3.png",
  ],
  priceDollars: 34,
  description:
    "Introducing the newest and coziest blanket in the Sundream lineup: the DreamPlush Throw. These throws are like wrapping yourself in a cloud—soft, dreamy, and irresistibly plush. Whether you’re curling up on the couch or catching a sunset, the DreamPlush throws bring next-level comfort to every moment.\n\n• Unreal Softness: Made from 100% polyester, these throws feel like wrapping up in a tropical cloud.\n• Perfectly Sized: Generous 50” x 60” dimensions—big enough for couch snuggles, solo Netflix binges, or cozy backyard hangs.\n• Family Favorite: Kids adore them (seriously, they’ll steal yours). Once you try it, no other blanket compares.\n• Everyday Cozy: great for indoor lounging or cozy evenings outside — your new go-to for any vibe.\n• So Many Options: Available in 6 dreamy styles and colors. You’ll want one for every room (and then some).\n• Gift-Worthy Goodness: The ultimate treat for yourself or a perfect gift that everyone will love.\n\nSummer Style, Western Style",
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:43.059Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
